const GYM = 'GYM';
const GYM_CMS = 'Gymboree';

const TCP = 'TCP';
const TCP_CMS = TCP;

const SNJ = 'SNJ';
const SNJ_CMS = SNJ;

const PJP = 'PJP';
const PJP_CMS = PJP;

const CLEARANCE = 'CLEARANCE';
const CLEARANCE_CMS = CLEARANCE;

const EMAIL = 'Email';

const ALL_BRANDS = [TCP, GYM, SNJ, PJP, CLEARANCE]; // don't change sequence, being used in tabs

const brandsMapping = {
  tcp: TCP_CMS,
  gym: GYM_CMS,
  snj: SNJ_CMS,
  pjp: PJP_CMS,
  clearance: CLEARANCE_CMS,
};
module.exports = {
  ALL_BRANDS,
  GYM,
  GYM_CMS,
  TCP,
  TCP_CMS,
  SNJ,
  SNJ_CMS,
  PJP,
  PJP_CMS,
  brandsMapping,
  EMAIL,
  CLEARANCE,
  CLEARANCE_CMS,
};
